var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 118.4 72.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:#1c2c58;}.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-8{fill:#fff;}.cls-9{fill:#d1a782;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9.06,
    y1: 72.52,
    x2: 9.06,
    y2: 50.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2c58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1a782"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 31.57,
    y1: 72.14,
    x2: 31.57,
    y2: 50.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 55.37,
    y1: 72.54,
    x2: 55.37,
    y2: 50,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 72.8,
    y1: 72.14,
    x2: 72.8,
    y2: 50.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 88.98,
    y1: 72.52,
    x2: 88.98,
    y2: 50.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 109.54,
    y1: 72.14,
    x2: 109.54,
    y2: 50.39,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "choice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.38,72.52q-5.49,0-8.44-2.79T0,61.73a13.29,13.29,0,0,1,1.36-6.21,9.78,9.78,0,0,1,3.87-4.06A11.71,11.71,0,0,1,11.16,50a16,16,0,0,1,3.4.36,10,10,0,0,1,2.75,1,23.43,23.43,0,0,1,.22,5.21h-1.6l-2.11-4.93,2,1.69a10.88,10.88,0,0,0-5-1.2q-6.55,0-6.55,8.81,0,9.47,7.56,9.47a10.33,10.33,0,0,0,5-1.23l-.13,1.27-2.93.27,2.71-5.1h1.69a21.37,21.37,0,0,1-.71,5.54,9.87,9.87,0,0,1-2.73,1A14.6,14.6,0,0,1,11.38,72.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.47,50.39l-.11,1.41a21.17,21.17,0,0,1-2.8.85L27,51v3.07H23.31V51l.38,1.47-2.93-.64.11-1.45ZM20.85,72.14l.11-1.4a19.11,19.11,0,0,1,2.79-.86l-.44,1.65V68.45H27v3.08l-.37-1.47,2.92.63-.11,1.45Zm2.46-.33V50.7H27V71.81Zm1.63-9.55V60.1H38.06v2.16ZM42.3,50.39l-.11,1.41a20.54,20.54,0,0,1-2.79.85L39.84,51v3.07H36.15V51l.37,1.47-2.92-.64.11-1.45ZM33.68,72.14l.11-1.4a19.92,19.92,0,0,1,2.79-.86l-.43,1.65V68.45h3.69v3.08l-.38-1.47,2.93.63-.11,1.45Zm2.47-.33V50.7h3.69V71.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.35,72.54a10.41,10.41,0,0,1-5.45-1.38,9.3,9.3,0,0,1-3.57-3.92,13.18,13.18,0,0,1-1.26-5.95,13.32,13.32,0,0,1,1.26-6,9.26,9.26,0,0,1,3.58-3.92,11.49,11.49,0,0,1,10.92,0,9.23,9.23,0,0,1,3.58,3.91,14.67,14.67,0,0,1,0,11.94,9.28,9.28,0,0,1-3.58,3.93A10.5,10.5,0,0,1,55.35,72.54Zm.57-2.15q5.53,0,5.54-8.31c0-3.19-.58-5.65-1.73-7.36a5.55,5.55,0,0,0-4.91-2.57q-5.53,0-5.54,8.3,0,4.81,1.73,7.38A5.59,5.59,0,0,0,55.92,70.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.1,50.39,77,51.8a20.54,20.54,0,0,1-2.79.85L74.64,51v3.07H71V51l.37,1.47-2.92-.64.11-1.45ZM68.49,72.14l.11-1.4a19.11,19.11,0,0,1,2.79-.86L71,71.53V68.45h3.69v3.08l-.37-1.47,2.92.63-.11,1.45ZM71,71.81V50.7h3.69V71.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.3,72.52q-5.51,0-8.44-2.79c-2-1.86-3-4.53-3-8a13.29,13.29,0,0,1,1.37-6.21,9.76,9.76,0,0,1,3.86-4.06A11.72,11.72,0,0,1,91.08,50a15.93,15.93,0,0,1,3.39.36,10,10,0,0,1,2.76,1,24.05,24.05,0,0,1,.22,5.21H95.84l-2.1-4.93,2,1.69a10.88,10.88,0,0,0-5-1.2q-6.54,0-6.55,8.81,0,9.47,7.56,9.47a10.33,10.33,0,0,0,5-1.23l-.13,1.27-2.92.27,2.7-5.1H98a21.33,21.33,0,0,1-.7,5.54,10.06,10.06,0,0,1-2.74,1A14.52,14.52,0,0,1,91.3,72.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.38,50.39l-.11,1.41a20.54,20.54,0,0,1-2.79.85l.44-1.64v3.07h-3.69V51l.37,1.47-2.92-.64.11-1.45Zm-8.61,21.75.11-1.4a19.11,19.11,0,0,1,2.79-.86l-.44,1.65V68.45h3.69v3.08l-.37-1.47,2.92.63-.11,1.45Zm2.46-.33V50.7h3.69V71.81Zm.59-19.22v-2.2h13.43l-.42,2.2Zm.92,9.58V59.79h9.65l-.18,2.38Zm.36,10V70H117l.53,2.19Zm10.81-15.88-2-4.62,3.32-1.25a21.94,21.94,0,0,1,.39,3,22.72,22.72,0,0,1,0,2.86Zm1.58,15.88L114,71l2.71-5.1h1.69a17,17,0,0,1-.2,2.9A24.09,24.09,0,0,1,117.49,72.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M68,37.57c-1.17.58-3.07-.58-4.34-.29-1.45.33-2.88,2.26-4.36,2.29-1.3,0-2.51-1.84-3.79-2.12-1.44-.32-3.58.81-4.93.2-1.19-.53-1.46-2.73-2.48-3.53-1.17-.9-3.59-.81-4.54-1.93s-.11-3.08-.69-4.23c-.65-1.32-2.88-2.27-3.24-3.68-.32-1.25,1.25-2.82,1.25-4.11,0-1.46-1.61-3.27-1.31-4.7.26-1.26,2.37-2,2.93-3.16.64-1.32,0-3.63.89-4.79s3-.79,4-1.59S49.05,2.66,50.37,2c1.16-.58,3.07.58,4.34.29C56.15,2,57.58,0,59.06,0c1.31,0,2.52,1.84,3.79,2.12,1.45.32,3.59-.81,4.94-.2,1.19.53,1.45,2.73,2.48,3.53s3.59.81,4.54,1.93.11,3.08.68,4.23c.65,1.32,2.88,2.27,3.25,3.68.32,1.25-1.26,2.82-1.25,4.11,0,1.46,1.6,3.27,1.31,4.7-.26,1.26-2.38,2-2.94,3.16-.63,1.32,0,3.63-.89,4.79s-3,.79-4,1.59S69.35,36.91,68,37.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M75.11,19.79A15.91,15.91,0,1,1,70.45,8.53a15.89,15.89,0,0,1,4.66,11.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.11,19.79A13.91,13.91,0,1,1,69,10a13.91,13.91,0,0,1,4.08,9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M49.94,20l4.48,4.48,2.34,2.34,2.34-2.34,9.36-9.35-2.34-2.34-9.36,9.35-4.48-4.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoice);
export default __webpack_public_path__ + "static/media/choice.8168d7f84eb03abbfd07264e3797856f.svg";
export { ForwardRef as ReactComponent };